import React from 'react';
import { Github, ArrowUpRight } from 'lucide-react';
import { portfolioData } from '../mock';
import { useReveal } from '../hooks/useReveal';

const About = () => {
  const [ref, visible] = useReveal();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-28 sm:py-36 px-5 sm:px-8 lg:px-12 border-t border-[hsl(var(--rule))]"
    >
      <div ref={ref} className={`max-w-6xl mx-auto reveal ${visible ? 'is-visible' : ''}`}>
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <div className="section-label mb-8">
              <span>01 / about</span>
            </div>
            <h2 className="display text-4xl sm:text-5xl leading-tight">
              A short version
              <br />
              of the long story.
            </h2>
          </div>

          <div className="lg:col-span-8 space-y-6 text-lg sm:text-xl leading-relaxed text-[hsl(var(--foreground))]">
            {portfolioData.about.paragraphs.map((p, i) => (
              <p key={i} data-testid={`about-paragraph-${i}`}>
                {p}
              </p>
            ))}

            <div
              data-testid="github-callout"
              className="mt-10 p-6 sm:p-7 border border-[hsl(var(--rule))] rounded-sm bg-[hsl(var(--surface))]"
            >
              <div className="mono text-[0.72rem] text-[hsl(var(--foreground-faint))] mb-3">
                // projects
              </div>
              <p className="text-lg text-[hsl(var(--foreground))] leading-relaxed">
                To explore my work,{' '}
                <a
                  data-testid="about-github-link"
                  href={portfolioData.personal.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-static text-[hsl(var(--accent))] inline-flex items-center gap-1.5"
                >
                  visit my GitHub
                  <ArrowUpRight className="w-4 h-4" />
                </a>
                . That's where the code, the experiments, and the things-in-progress live.
              </p>
              <div className="mt-4 flex items-center gap-2 mono text-xs text-[hsl(var(--foreground-faint))]">
                <Github className="w-3.5 h-3.5" />
                <span>github.com/tah-rak</span>
              </div>
            </div>
          </div>
        </div>

        {/* Education strip */}
        <div className="mt-24 pt-12 border-t border-[hsl(var(--rule))]">
          <div className="section-label mb-10">
            <span>education</span>
          </div>
          <div className="grid md:grid-cols-2 gap-10">
            {portfolioData.education.map((edu, i) => (
              <div
                key={edu.id}
                data-testid={`education-${i}`}
                className="group"
              >
                <div className="flex items-baseline justify-between gap-4 mb-3">
                  <h3 className="display text-2xl">{edu.degree}</h3>
                  <span className="mono text-[0.72rem] text-[hsl(var(--foreground-faint))] whitespace-nowrap">
                    {edu.gpa}
                  </span>
                </div>
                <p className="text-[hsl(var(--foreground-muted))] mb-1">{edu.institution}</p>
                <p className="mono text-xs text-[hsl(var(--foreground-faint))] mb-4">
                  {edu.duration}
                </p>
                <div className="flex flex-wrap gap-2">
                  {edu.coursework.map((c, idx) => (
                    <span
                      key={idx}
                      className="mono text-[0.7rem] px-2.5 py-1 border border-[hsl(var(--rule))] rounded-full text-[hsl(var(--foreground-muted))] hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))] transition-colors"
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
